import { gql } from "@stadium/services/apollo-client";

export const USER_LOGO_STATUS = gql`
  fragment UserLogoStatus on User {
    id
    hasUploadedLogos
  }
`;
